/**
 * API: regiones / heatmap departamental (Sprint 14.4 backend, 14.5 frontend).
 *
 * Sprint Unificación Captación GESPROY (mayo 27, 2026): eliminamos el
 * toggle Histórico ↔ Reciente. La ficha usa una sola fuente
 * (`sgr_projects_historical` / GESPROY) en TODOS los lugares —
 * header, score hero, heatmap, drill-down — para que la cifra de
 * captación sea siempre la misma y verificable. El query param `scope`
 * fue removido del endpoint; el FE deja de enviarlo.
 */

import { request } from "./_client";

export interface HeatmapMuniDTO {
  dane_code: string;
  name: string;
  project_count: number;
  total_cop: string; // string para preservar precisión decimal
  intensity: number; // 0-1
  is_focal: boolean;
}

export interface HeatmapDTO {
  department_code: string;
  department_name: string;
  munis: HeatmapMuniDTO[];
  total_munis: number;
  max_total_cop: string;
  data_as_of: string; // ISO-8601
}

/** Heatmap SGR del departamento.
 *
 * - `focalDane` opcional resalta el muni del usuario en el payload
 *   (campo `is_focal=true`).
 *
 * Fuente única: GESPROY (`sgr_projects_historical`) — el BE ya no
 * acepta `scope`, así que no lo enviamos.
 */
export function fetchDepartmentHeatmap(
  departmentCode: string,
  focalDane?: string | null,
): Promise<HeatmapDTO> {
  const params = new URLSearchParams();
  if (focalDane) params.set("focal_dane", focalDane);
  const qs = params.toString();
  const suffix = qs ? `?${qs}` : "";
  return request<HeatmapDTO>(`/regions/${encodeURIComponent(departmentCode)}/heatmap${suffix}`);
}
